import { render, staticRenderFns } from "./SelectSchool.vue?vue&type=template&id=8d127e06"
import script from "@/components/select-school/SelectSchool.ts?vue&type=script&lang=ts&external"
export * from "@/components/select-school/SelectSchool.ts?vue&type=script&lang=ts&external"
import style0 from "./select-school.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports